<div class="d-flex" *ngIf="isProductMessage">
    <p class="font-omicron-medium m-0 p-0 text-size-low color-black not-available-message-content"
        *ngIf="product.itemCodeHasMissing && product.arriveDateProduct && !hasMissingPrinciplesActives && !isInvalidFromProduct">
        Producto disponible apróx. a partir del
        {{ product.arriveDateProduct | date: "dd MMM":"MX" | titlecase }}
    </p>
    <p class="font-omicron-medium m-0 p-0 text-size-low color-black not-available-message-content"
        *ngIf="product.itemCodeHasMissing && !product.arriveDateProduct && !hasMissingPrinciplesActives && !isInvalidFromProduct">
        Producto agotado temporalmente
    </p>
    <p class="font-omicron-medium m-0 p-0 text-size-low color-black not-available-message-content" #tooltip="matTooltip"
        matTooltip="{{fullMissingPrinciplesActives}} agotado temporalmente" matTooltipPosition="left"
        *ngIf="product.itemCodeHasMissing && !product.arriveDateProduct && hasMissingPrinciplesActives && !isInvalidFromProduct">
        <span class="font-omicron-bold">{{ missingPrinciplesActives}}</span> agotado temporalmente
    </p>
    <p class="font-omicron-medium m-0 p-0 text-size-low color-black not-available-message-content" #tooltip="matTooltip"
        matTooltip="{{fullMissingPrinciplesActives}} disponible apróx. a partir del
            {{ product.arriveDateProduct | date: 'dd MMM':'MX' | titlecase}} " matTooltipPosition="left"
        *ngIf="product.itemCodeHasMissing && product.arriveDateProduct && hasMissingPrinciplesActives && !isInvalidFromProduct">
        <span class="font-omicron-bold"> {{missingPrinciplesActives}} </span> disponible apróx. a partir del
        {{ product.arriveDateProduct | date: "dd MMM":"MX" | titlecase }}
    </p>
    <p class="font-omicron-medium m-0 p-0 text-size-low color-black not-available-message-content"
        *ngIf="product.itemCodeHasMissing && isInvalidFromProduct">
        Producto no disponible
    </p>
</div>
<div class="d-flex" *ngIf="!isProductMessage">
    <p class="font-omicron-medium m-0 text-size-low color-black not-available-message-content" *ngIf="
    product.productAttributes[attributeIndex].containerHasMissing &&
    !product.productAttributes[attributeIndex].arriveDateContainer">
        Envase agotado temporalmente
    </p>
    <p class="font-omicron-medium m-0 text-size-low color-black not-available-message-content" *ngIf="
    product.productAttributes[attributeIndex].containerHasMissing &&
    product.productAttributes[attributeIndex].arriveDateContainer">
        Envase disponible apróx. a partir del
        {{
        product.productAttributes[attributeIndex].arriveDateContainer
        | date: "dd MMM":"MX"
        | titlecase
        }}
    </p>
</div>